import { CplEventAction, EventType } from "../utils";

import { CplLyticsEvent } from "./lytics-tracker.types";

const lyticsEventTracker = (event: EventType) => (
  cplName: string,
  email: string,
  action: CplEventAction
) => {
  try {
    const cplTrackEventObject: CplLyticsEvent = {
      event,
      cplName,
      email,
      hasUserAcceptedOffer:
        action === CplEventAction.CLICK_YES
          ? true
          : action === CplEventAction.CLICK_NO
          ? false
          : "null",
    };
    window.jstag?.send(cplTrackEventObject);
  } catch (error) {
    console.error(error);
  }
};

export const cplOptInLyticsEventTracker = lyticsEventTracker(
  EventType.CPL_OPT_IN
);
